/* @flow */

import type { Point, Tools, SpriteAnimationConfig, SpriteAnimationStepConfig } from './Common';
import { GridHeight } from './Common';
import GlobalManager from './GlobalManager';

class SpriteStep {
  image: Image;
  imageMirrored: Image;
  width: number;
  height: number;
  duration: number;

  constructor(spriteImageUrl: string, spriteLoader: SpriteAnimationStepConfig) {
    this.width = spriteLoader.width;
    this.height = spriteLoader.height;
    this.duration = spriteLoader.duration;

    this.image = new Image();
    this.imageMirrored = new Image();

    // create mirrored
    const self = this;
    self.image.onload = () => {
      const tempCanvas = document.createElement('canvas');
      tempCanvas.width = self.image.width;
      tempCanvas.height = self.image.height;
      const tempCtx = tempCanvas.getContext('2d');
      tempCtx.scale(-1, 1);
      tempCtx.drawImage(self.image, -self.image.width, 0);
      self.imageMirrored.src = tempCanvas.toDataURL();
    };
    self.image.src = spriteImageUrl;
  }

  draw(
    tools: Tools,
    position: Point,
    useMirrored: boolean,
    targetWidth: number,
    targetHeight: number
  ) {
    const { image, imageMirrored, width, height } = this;
    tools.ctx.drawImage(
      useMirrored ? imageMirrored : image,
      0,
      0,
      width,
      height,
      position.x - targetWidth / 2,
      GridHeight - (position.y + targetHeight),
      targetWidth,
      targetHeight
    );
  }
}

export class CustomSprite {
  steps: Array<SpriteStep> = [];
  stepsByTick: Array<SpriteStep> = [];
  width: number;
  height: number;

  constructor(sheetLoader: SpriteAnimationConfig) {
    const sheetUrl = GlobalManager.config.assetsUrl + 'sprite/' + sheetLoader.file;
    const self = this;
    const sheetImage = new Image();
    if (GlobalManager.config.environment !== 'demo') {
      sheetImage.crossOrigin = 'Anonymous';
    }
    sheetImage.onload = function() {
      self.steps = sheetLoader.steps.map(spriteLoader => {
        const tempCanvas = document.createElement('canvas');
        tempCanvas.width = spriteLoader.width;
        tempCanvas.height = spriteLoader.height;
        const tempCtx = tempCanvas.getContext('2d');
        tempCtx.drawImage(
          sheetImage,
          spriteLoader.sheetPosition.x,
          spriteLoader.sheetPosition.y,
          spriteLoader.width,
          spriteLoader.height,
          0,
          0,
          spriteLoader.width,
          spriteLoader.height
        );
        const spriteImageSrc = tempCanvas.toDataURL();
        return new SpriteStep(spriteImageSrc, spriteLoader);
      });
      self.steps.forEach(step => {
        for (var i = 0; i < step.duration; i++) {
          self.stepsByTick.push(step);
        }
      });
    };
    sheetImage.src = sheetUrl;
  }
  draw(
    tools: Tools,
    duration: number,
    position: Point,
    useMirrored: boolean,
    width: number,
    height: number
  ) {
    const { stepsByTick } = this;
    const stepIndex = duration % stepsByTick.length;
    const spriteStep = stepsByTick[stepIndex];
    if (spriteStep) {
      spriteStep.draw(tools, position, useMirrored, width, height);
    }
  }
}

export class HasSprite {
  duration = 0;

  draw(
    tools: Tools,
    sprite: CustomSprite,
    position: Point,
    backwards: boolean,
    width: number,
    height: number
  ) {
    sprite.draw(tools, this.duration, position, backwards, width, height);
  }
  step() {
    this.duration += 1;
  }
}



// WEBPACK FOOTER //
// ./src/Sprite.js